import type { FC, ReactNode } from 'react';

export const MetadataItem: FC<{ label: string; value: ReactNode }> = ({ label, value }) => (
    <div className="flex flex-col gap-1">
        <div className="text-sm text-muted-foreground">{label}</div>
        <div className="text-base text-card-foreground">{value}</div>
    </div>
);
